import { render, staticRenderFns } from "./OpusMall.vue?vue&type=template&id=0b241788&scoped=true"
import script from "./OpusMall.vue?vue&type=script&lang=js"
export * from "./OpusMall.vue?vue&type=script&lang=js"
import style0 from "./OpusMall.vue?vue&type=style&index=0&id=0b241788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b241788",
  null
  
)

export default component.exports